
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nos-produits",
      function () {
        return require("private-next-pages/nos-produits/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nos-produits"])
      });
    }
  